import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import CONFIG from "../../../config.json";
export const GET_LEADERSHIP_LIST = 'GET_LEADERSHIP_LIST'
export const ADD_LEADERSHIP = 'ADD_LEADERSHIP'
export const DELETE_LEADERSHIP = 'DELETE_LEADERSHIP'
export const UPDATE_LEADERSHIP = 'UPDATE_LEADERSHIP'
export const getLeadership = () => (dispatch) => {
    axios.get(CONFIG.SERVER_URL+'leadership').then((res) => {
        dispatch({
            type: GET_LEADERSHIP_LIST,
            payload: JSON.parse(res.data.data),
        })
    })

}

export const addLeadership = (data) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    console.log('getData', data)
    if(data.file){
        formData.append(
            "file",
            data.file,
            data.file.name,
            );
    }
    formData.append(
        "name",
        data.name
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "description",
        data.description
    );
    formData.append(
        "designation",
        data.designation
    );
    formData.append(
        "ordering",
        data.ordering
    );
    axios.post(CONFIG.SERVER_URL+'leadership/add/', formData).then((res) => {
        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        dispatch({
            type: ADD_LEADERSHIP,
            payload: res.data.data,
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}

export const deleteLeadership = (id) => (dispatch) => {
    
    axios.post(CONFIG.SERVER_URL+'leadership/delete/'+id).then((res) => {

        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: DELETE_LEADERSHIP,
            payload: res.data,
            id
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}
export const updateLeadership = (data, id) => (dispatch) => {
    const formData = new FormData();

    // Update the formData object 
    console.log('getData', data)
    if(data.file){
        formData.append(
            "file",
            data.file,
            data.file.name,
        );
    }
    formData.append(
        "name",
        data.name
    );
    formData.append(
        "status",
        data.status
    );
    formData.append(
        "description",
        data.description
    );
    formData.append(
        "designation",
        data.designation
    );
    formData.append(
        "ordering",
        data.ordering
    );
    axios.post(CONFIG.SERVER_URL+'leadership/update/'+id, formData).then((res) => {
        if(res.data.status == true){
            toast.success(res.data.msg);
        }else{
            toast.error(res.data.msg);
        }
        // axios.post(CONFIG.SERVER_URL+'leadership/delete/1000').then((res) => {
        dispatch({
            type: UPDATE_LEADERSHIP,
            payload: res.data.data,
            id
        })
    }).catch((error)=> {
        toast.error("Something went wrong");
    })
}
